export enum NoneEnum {
  NONE = 'NONE'
}
